"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dActionSagas = void 0;
var effects_1 = require("redux-saga/effects");
var DactionAction_1 = require("@/pages/developments/actions/DactionAction");
var DevelopmentsApi_1 = require("@/api/remote/public/DevelopmentsApi");
var DevelopmentsAction_1 = require("@/pages/developments/actions/DevelopmentsAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var DbarAction_1 = require("@/pages/developments/actions/DbarAction");
var DbarState_1 = require("@/pages/developments/states/dbar/DbarState");
var WindowApi_1 = require("@/api/browser/WindowApi");
var watchOnChangeDistrict = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DactionAction_1.default.ON_CHANGE_DISTRICT)];
            case 1:
                action = _a.sent();
                return [4 /*yield*/, effects_1.put(DactionAction_1.default.changeDistrict(action.payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnChangeSort = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var action, state, language, languageCode, result, url, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(DactionAction_1.default.ON_CHANGE_SORT)];
                            case 1:
                                action = _a.sent();
                                return [4 /*yield*/, effects_1.put(DactionAction_1.default.changeSort(action.payload))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select()];
                            case 3:
                                state = _a.sent();
                                _a.label = 4;
                            case 4:
                                _a.trys.push([4, 8, , 10]);
                                language = state.layout.language.languages
                                    .filter(function (it) { return it.id === state.layout.language.current; })[0];
                                languageCode = language.code1;
                                return [4 /*yield*/, effects_1.call(DevelopmentsApi_1.getDevelopmentProjects, languageCode, state.developments.pageNumber, action.payload, 0)];
                            case 5:
                                result = _a.sent();
                                url = "/" + languageCode + "/new-developments/" + state.developments.pageNumber + "/" + action.payload;
                                return [4 /*yield*/, effects_1.call(WindowApi_1.setAddressBar, url)];
                            case 6:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(DevelopmentsAction_1.default.reloadProjects(result.data.developments))];
                            case 7:
                                _a.sent();
                                return [3 /*break*/, 10];
                            case 8:
                                e_1 = _a.sent();
                                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSearchError'))];
                            case 9:
                                _a.sent();
                                console.log(e_1);
                                return [3 /*break*/, 10];
                            case 10: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnClickDactionClear = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DactionAction_1.default.ON_CLICK_DACTION_CLEAR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbarAction_1.default.setDbarPop(DbarState_1.DbarPops.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnClickDactionConfirm = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DactionAction_1.default.ON_CLICK_DACTION_CONFIRM)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DbarAction_1.default.setDbarPop(DbarState_1.DbarPops.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var dActionSagas = {
    watchOnChangeDistrict: watchOnChangeDistrict,
    watchOnChangeSort: watchOnChangeSort,
    watchOnClickDactionClear: watchOnClickDactionClear,
    watchOnClickDactionConfirm: watchOnClickDactionConfirm,
};
exports.dActionSagas = dActionSagas;
